

import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";

export function WelcomeMessageInput() {
  const { t } = useTranslation();
  const welcomeMessage = SettingsStore(state => state.welcomeMessage);
  const setWelcomeMessage = SettingsStore(state => state.setWelcomeMessage);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <div className="space-y-2">
      <Label htmlFor="welcome-message">{t("settings.welcomeMessage")}</Label>
      <Textarea
        id="welcome-message"
        className="[field-sizing:content] max-h-[500px] min-h-[80px]"
        value={welcomeMessage}
        onChange={(e) => setWelcomeMessage(e.target.value)}
        placeholder={t("common.enterWelcomeMessage")}
        disabled={isLoading}
      />
    </div>
  );
}